module.exports = __webpack_public_path__ + "img/petshop.aa359505.jpg";